var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "content_copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.7502 0.833008H3.75016C2.8335 0.833008 2.0835 1.58301 2.0835 2.49967V14.1663H3.75016V2.49967H13.7502V0.833008ZM16.2502 4.16634H7.0835C6.16683 4.16634 5.41683 4.91634 5.41683 5.83301V17.4997C5.41683 18.4163 6.16683 19.1663 7.0835 19.1663H16.2502C17.1668 19.1663 17.9168 18.4163 17.9168 17.4997V5.83301C17.9168 4.91634 17.1668 4.16634 16.2502 4.16634ZM16.2502 17.4997H7.0835V5.83301H16.2502V17.4997Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content_copy.0760ea1747b13a0b1e1f372fb8f14cf3.svg";
export { ForwardRef as ReactComponent };